import React from 'react'
import { VisualShape } from 'types'
import { useLandingContent } from '../hooks/i18n/usePageContent.js'
import * as TOKENS from './chat/design-tokens'

interface MultimodalShowcaseProps {
  onShapeChange?: (shape: VisualShape) => void
  onStartChat?: () => void
}

const MultimodalShowcase: React.FC<MultimodalShowcaseProps> = ({ onStartChat }) => {
  const { multimodal } = useLandingContent()

  return (
    <section
      className={`relative z-10 w-full scroll-mt-24 border-t ${TOKENS.BORDER.default} bg-transparent px-6 py-20 md:px-12`}
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-12">
        <div className="flex max-w-2xl flex-col gap-3">
          <span className={`${TOKENS.TEXT_SIZE.xs} font-mono uppercase tracking-[0.25em] ${TOKENS.TEXT.muted}`}>
            {multimodal.eyebrow}
          </span>
          <h2 className={`${TOKENS.TEXT_SIZE['2xl']} font-semibold tracking-tight md:text-3xl ${TOKENS.TEXT.primary}`}>
            {multimodal.title}
          </h2>
          <p className={`text-base font-light leading-relaxed ${TOKENS.TEXT.secondary}`}>
            {multimodal.body}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-px border border-border bg-border md:grid-cols-2">
          {multimodal.capabilities.map(cap => (
            <div
              key={cap.id}
              className={`flex flex-col gap-2 ${TOKENS.PADDING.lg} ${TOKENS.SURFACE_ROLES.raised} border-0 transition-colors duration-150 hover:bg-muted`}
            >
              <span className={`font-mono text-[10px] uppercase tracking-[0.22em] ${TOKENS.BRAND.accent}`}>
                {cap.tag}
              </span>
              <span className={`text-sm font-semibold ${TOKENS.TEXT.primary}`}>{cap.label}</span>
              <span className={`text-xs leading-6 ${TOKENS.TEXT.secondary}`}>{cap.detail}</span>
            </div>
          ))}
        </div>

        {onStartChat && (
          <div>
            <button
              type="button"
              onClick={onStartChat}
              className={`group relative overflow-hidden ${TOKENS.PATTERNS.marketingPrimaryLarge}`}
            >
              <span className={TOKENS.INTERACTION.shimmer} />
              <span className="relative">{multimodal.marketingCta}</span>
            </button>
          </div>
        )}
      </div>
    </section>
  )
}

export default MultimodalShowcase
